<template>
  <div class="sidebar">
    <NavMenu></NavMenu>
  </div>
</template>

<script>
  import NavMenu from '../sidebar/NavMenu.vue';

  export default {
    name: 'Sidebar',
    components: {
      NavMenu,
    },
  };
</script>
